import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const configApi = createApi({
  reducerPath: 'configApi',
  tagTypes: ['Config'],
  baseQuery: fetchBaseQuery({
    baseUrl: window.location.origin,
  }),
  refetchOnReconnect: true,
  endpoints: (build) => ({
    getConfig: build.query<any, void, any>({
      query: () => (import.meta.env.MODE === 'dev') ? 'config-local.json' : 'config.json',
      providesTags: ['Config'],
    }),
  }),
});

export const { useGetConfigQuery } = configApi;